import React from 'react';
import styles from './range-slider.module.scss';

interface RangeSliderProps {
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
  /**
   * Fires on drag release (mouse up / touch end / key up). Use this for
   * expensive work that shouldn't run on every tick of a drag.
   */
  onCommit?: (value: number) => void;
  minLabel?: string;
  maxLabel?: string;
  disabled?: boolean;
}

export function RangeSlider({
  min,
  max,
  step = 1,
  value,
  onChange,
  onCommit,
  minLabel,
  maxLabel,
  disabled = false,
}: RangeSliderProps) {
  const fillPct = max > min ? ((value - min) / (max - min)) * 100 : 0;

  const handleCommit = (e: React.SyntheticEvent<HTMLInputElement>) => {
    onCommit?.(Number(e.currentTarget.value));
  };

  return (
    <div className={styles.sliderRow}>
      {minLabel && <span className={styles.rangeLabel}>{minLabel}</span>}
      <div className={styles.sliderWrapper}>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(e) => onChange(Number(e.target.value))}
          onMouseUp={handleCommit}
          onTouchEnd={handleCommit}
          onKeyUp={handleCommit}
          className={styles.slider}
          style={{ '--fill': `${fillPct}%` } as React.CSSProperties}
          disabled={disabled}
        />
      </div>
      {maxLabel && <span className={styles.rangeLabel}>{maxLabel}</span>}
    </div>
  );
}
